<style scooped>
.animate__animated{
  animation-duration:900ms;
}
.animate__fadeIn
{
  animation-duration:1700ms;
}
</style>

<template>
  <div id="app">

    
   <transition @before-enter="scrollTop"
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight animate__fadeIn"
      leave-active-class="animate__animated animate__slideOutLeft animate__fadeOut"
      mode="out-in"
    >
      <router-view class="view" />
    </transition>


    <!-- <transition @before-enter="scrollTop" mode="out-in" appear>
    <router-view />
    </transition> -->
    <a id="phoneLink" href="tel: +359889469526">
    <img id="phoneIconImage" src="@/assets/images/simple-finance-images/phone-icon.png" alt="" style="pointer-events: auto !important">
    </a>
  </div>
</template>
<script>
export default {
  methods: {
  scrollTop(){
   document.getElementById('app').scrollIntoView();
  },
}
}
</script>
<style scoped>
@media (min-width: 500px) {
    #phoneIconImage
    {
      visibility: hidden;
    }
}
#phoneLink:hover
{
  cursor: pointer;
}
#phoneIconImage
{
  opacity: 1;
  position: fixed;
  right: 4%;
  bottom: 4%;
  width: 16%;
}
</style>
